var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((Object.entries(_vm.model)),function([id,value]){return _c('div',[_c(_vm.model_type(id),{tag:"component",attrs:{"bp":_vm.bp,"name":id,"data":value,"readonly":_vm.readonly,"lang":_vm.lang,"is_mobile":_vm.is_mobile,"roles":_vm.roles},on:{"update":_vm.update}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }